export const themeOptionFactory = (theme) => ({
  assets: {
    benchasiriPark: {
      mime: "image/png",
      url: "https://s3.venue.in.th/dreamstime_xxl_92963113_1_058c860290.png",
      width: 564,
      height: 376,
    },
  },
  components: {
    EmBenchasiriPage: {
      styleOverrides: {
        root: {
          minHeight: `calc(100dvh - ${theme.mixins.mobileHeader?.height}px - ${
            theme.mixins.mobileBottomNavigation?.height + 30
          }px - 64px)`,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        },
        image: {
          width: "100%",
          borderRadius: "20px",
        },
        titleText: {
          fontSize: "2.8rem",
          letterSpacing: "0.325rem",
          fontWeight: 700,
          lineHeight: "1.15",
        },
        titleWrapper: { marginTop: theme.spacing(3) },
        descriptionWrapper: { marginTop: theme.spacing(2) },
        descriptionText: {
          fontSize: "0.875rem",
        },
        ctaWrapper: {
          display: "flex",
          justifyContent: "center",
          marginTop: theme.spacing(3),
        },
        ctaButton: {
          borderRadius: "100px",
          textTransform: "uppercase",
          fontWeight: 700,
          padding: theme.spacing(1.5, 3),
        },
        eventSection: {
          display: "flex",
          height: "112px",
          marginTop: theme.spacing(2),
          padding: theme.spacing(1, 1, 1, 3),
          gap: theme.spacing(1.25),
          overflowX: "auto",
          width: "100vw",
          marginRight: theme.spacing(-3),
          marginLeft: theme.spacing(-3),
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
        },
        eventItemContainer: {
          flexBasis: "284px",
          flexShrink: 0,
        },
      },
    },
    EmBenchasiriEventCard: {
      styleOverrides: {
        root: {
          display: "block",
          width: "100%",
          height: "100%",
          borderRadius: "16px",
          boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.15)",
        },
        content: {
          display: "flex",
          padding: theme.spacing(1),
          gap: theme.spacing(1),
          "&:last-child": { paddingBottom: theme.spacing(1) },
        },
        media: { borderRadius: "8px", width: "30%", aspectRatio: "1" },
        textContainer: { display: "flex", flexDirection: "column" },
        titleText: {
          marginBottom: theme.spacing(1),
          fontSize: "0.875rem",
          fontWeight: 600,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
        },
        subtitleText: { fontSize: "0.625rem" },
      },
    },
  },
})
